// @flow
import * as React from 'react';

type Props = {
  onClickOutside: Function,
  children: any
};

export default class ClickOutside extends React.PureComponent<Props> {
  isTouch = false;

  containerRef = React.createRef<HTMLDivElement>();

  componentDidMount() {
    document.addEventListener('touchend', this.handle, true);
    document.addEventListener('click', this.handle, true);
  }

  componentWillUnmount() {
    document.removeEventListener('touchend', this.handle, true);
    document.removeEventListener('click', this.handle, true);
  }

  handle = (e: TouchEvent | MouseEvent) => {
    if (e.type === 'touchend') this.isTouch = true;
    if (e.type === 'click' && this.isTouch) return;
    const { onClickOutside } = this.props;
    const el = this.containerRef.current;
    if (el && e.target instanceof Node && !el.contains(e.target))
      onClickOutside(e);
  };

  render() {
    const { children, onClickOutside, ...props } = this.props;
    return (
      <div {...props} ref={this.containerRef}>
        {children}
      </div>
    );
  }
}
